var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"screenContent",class:_vm.bean.destinyScreenStyleClass})
}
var staticRenderFns = []

export { render, staticRenderFns }